export default __webpack_public_path__ + "static/media/9.3d604c29.svg";